module.exports = __webpack_public_path__ + "static/media/image-bg-preview-storygame-mo.bec30315.png";